/**
 * @file wrapPageElement configuration for Gatsby
 * @author Ryszard Trojnacki
 */
import React from 'react';
import { I18nextProvider } from "react-i18next"
import i18n from "./i18n";
import { Layout } from "../components/Layout";

export const wrapPageElement = ({ element, props }) => {
    const { pageContext, location } = props;
    const lang = pageContext?.lang || 'en';
    if(i18n.language !== lang) {
        i18n.changeLanguage(lang);
    }

    if (location.pathname.startsWith('/wishlist')) {
        return <I18nextProvider i18n={i18n}>{element}</I18nextProvider>;
    }

    return <I18nextProvider i18n={i18n}>
        <Layout location={location}>
            {element}
        </Layout>
    </I18nextProvider>
}